// NPM
import { createI18n } from "vue-i18n";

// Locales
import en from "@/locales/en.json";
import fr from "@/locales/fr.json";

const supportedLocales = ["en", "fr"];

const browserLocale =
  typeof navigator !== "undefined" ? navigator.language.split("-")[0] : "en";

const locale = supportedLocales.includes(browserLocale) ? browserLocale : "en";

console.log("🌍 i18n init with locale:", locale);

localStorage.debug = "vue-i18n:*"; // Enable debug logging for i18n

export default createI18n({
  legacy: false,
  globalInjection: true,
  fallbackLocale: locale,
  locale,
  messages: {
    en,
    fr,
  },
  missingWarn: false,
  fallbackWarn: false,
});
